import { fbId, socialShareData as data } from 'constants/params'

export default class SocialShare {
  constructor(title, description) {
    this.title = title
    this.description = description
  }

  _share(url, params) {
    let left = Math.round(screen.width/2 - params.width/2);
    let top = 0;

    if (screen.height > params.height)
    top = Math.round(screen.height/3 - params.height/2);

    window.open(url, params.id, 'left=' + left + ',top=' + top + ',' +
    'width=' + params.width + ',height=' + params.height + ',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
  }

  vk() {
    window.ga('send', 'event', 'Социальная активность', 'Клик с экрана результата', 'vkontakte')

    const url = 'https://vk.com/share.php?url=' + data.url
      + '&title=' + encodeURIComponent(this.title)
      + '&description=' + encodeURIComponent(this.description)
      + '&image=' + encodeURIComponent(data.picture)

    const params = {width:655, height:450, id:'popup-vk'}

    this._share(url, params)
  }

  fb() {
    window.ga('send', 'event', 'Социальная активность', 'Клик с экрана результата', 'facebook')

    const url =  'http://www.facebook.com/dialog/feed?app_id=' + fbId
      + '&link=' + data.url
      + '&picture=' + data.picture
      + '&name=' + encodeURIComponent(this.title)
      + '&description=' + encodeURIComponent(this.description)
      + '&redirect_uri=' + data.url
      + '&display=popup'

    const params = {width:600, height:359, id:'popup-fb'}

    this._share(url, params)
  }

  tw() {
    window.ga('send', 'event', 'Социальная активность', 'Клик с экрана результата', 'twitter')

    var url =  'http://twitter.com/share?text=' + this.title
      + ' ' + this.description + ' ' + '&url=' + data.url;

    var params = {width:655, height:450, id:'popup-tw'}

    this._share(url, params)
  }
}



// WEBPACK FOOTER //
// ./src/lib/share.js